import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash"
import { Button, Grid, Typography, Divider,  Box, TextField, Checkbox, MenuItem } from '@mui/material'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { selectCountrys } from '../../../reducers/reference_country';
import { selectEducations } from '../../../reducers/reference_education';
import { selectSpokenLanguages } from '../../../reducers/reference_spokenlanguage';
import { selectRaceEntities } from '../../../reducers/reference_race';
import { selectBirthSexs } from '../../../reducers/reference_birthsex';
import { adminparticipantClearCreate, createParticipants } from '../../../reducers/admincenter_participants';
import { selectErrorMessagesByNegativeCode } from '../../../reducers/reference_errormessages';
import { selectGroupSelectTree } from '../../../reducers/admincenter_groups';


import DropdownTreeSelect from 'react-dropdown-tree-select'

const ParticipantCreate = (props) => {
    const dispatch = useDispatch()
    const { user: currentUser } = useSelector((state) => state.auth);
    
    const countryData = useSelector(state => selectCountrys(state))
    const educationData = useSelector(state => selectEducations(state))
    const languageData = useSelector(state => selectSpokenLanguages(state))
    const raceData = useSelector(state => selectRaceEntities(state))
    const birthSexData = useSelector(state => selectBirthSexs(state))

    const langOptions = languageData.map((x) => { return (<MenuItem value={x.LanguageTypeId}>{x.StandardContent}</MenuItem>) })
    const eduOptions = educationData.map((x) => { return (<MenuItem value={x.EducationTypeGuid}>{x.EducationTypeName}</MenuItem>) })
    //const countryOptions = countryData.map((x) => { return (<MenuItem value={x.CountryId}>{x.StandardContent}</MenuItem>) })
    const birthSexOptions = birthSexData.map((x) => { return (<MenuItem value={x.GenderTypeId}>{x.GenderTypeName}</MenuItem>) })
    const raceOptions = raceData.map((x) => { return (<MenuItem value={x.RaceTypeId}>{x.RaceTypeName}</MenuItem>) })

    const createParticipantError = useSelector(state => state.adminparticipants.errorCreate)
    const createParticipantStatus = useSelector(state => state.adminparticipants.statusCreate)
    const [isError, setIsError] = useState(false)
    const ErrorMessage = useSelector(state => selectErrorMessagesByNegativeCode(state, createParticipantError && createParticipantError.ErrorID))

    const [GroupGuid, setGroupGuid] = useState("")
    const [LanguageID, setLanguageID] = useState("1")
    const [FirstName, setFirstName] = useState("")
    const [LastName, setLastName] = useState("")
    const [MiddleName, setMiddleName] = useState("")
    const [BioDOB, setBioDOB] = useState("")
    const [BioGender, setBioGender] = useState("")
    const [BioRace, setBioRace] = useState("")
    const [SpokenLanguageID, setSpokenLanguageID] = useState("")
    const [Email, setEmail] = useState("")
    const [StatusID, setStatusID] = useState("1")
    const [EducationLevelGuid, setEducationLevelGuid] = useState("")
    const [Medicaid, setMedicaid] = useState("0")
    const [Username, setUsername] = useState("")
    const [Password, setPassword] = useState("")
    const [PasswordChangeRequired, setPasswordChangeRequired] = useState("0")
    
    const datToday = new Date(new Date().setDate(new Date().getDate()-1));
    const dat120 = new Date()    
    dat120.setFullYear(dat120.getFullYear()-120)
    const validDob = !BioDOB || (new Date(BioDOB) >=dat120 && new Date(BioDOB)<datToday)

    const [errorGroupGuid, setErrorGroupGuid] = useState(false)
    const [errorUsername, setErrorUsername] = useState(false)
    const [errorPassword, setErrorPassword] = useState(false)

    const GroupTreeSelect = useSelector(state=> selectGroupSelectTree(state,GroupGuid))

    const SaveToDatabase = () => {
        setErrorGroupGuid(false)
        setErrorUsername(false)
        setErrorPassword(false)
        
        if (GroupGuid
            && StatusID
            && Username
            && Password
        ) {
            let body = {
                GroupGuid: GroupGuid
                , LanguageID: LanguageID ? LanguageID : "~_~"
                , FirstName: FirstName ? FirstName : "~_~"
                , LastName: LastName ? LastName : "~_~"
                , MiddleName: MiddleName ? MiddleName : "~_~"
                , BioDOB: BioDOB ? BioDOB : "~_~"
                , BioGender: BioGender ? BioGender : "~_~"
                , BioRace: BioRace ? BioRace : "~_~"
                , SpokenLanguageID: SpokenLanguageID ? SpokenLanguageID : "~_~"
                , Email: Email ? Email : "~_~"
                , StatusID: StatusID ? StatusID : "~_~"
                , EducationLevelGuid: EducationLevelGuid ? EducationLevelGuid : "~_~"
                , Medicaid: Medicaid ? Medicaid : "~_~"
                , Username: Username ? Username : "~_~"
                , Password: Password ? Password : "~_~"
                , PasswordChangeRequired: PasswordChangeRequired ? PasswordChangeRequired : "~_~"
                , AuthToken: currentUser.AuthToken
            }

            dispatch(createParticipants(body))
        } else {
            if(!GroupGuid) {setErrorGroupGuid(true)}
            if(!Username) {setErrorUsername(true)}
            if(!Password) {setErrorPassword(true)}
        }
    }

   

    const onChange = (currentNode, selectedNodes) => {        
            setGroupGuid(currentNode.value)
        
    }

    useEffect(() => {
        setIsError(false)
        if (createParticipantStatus === "success") {
            dispatch(adminparticipantClearCreate())
            props.onCloseButton()
        }
        if (createParticipantStatus === "failed") {
            setIsError(true)
        }
    }, [dispatch, createParticipantStatus])


    return (
        <Box>
            <Grid container direction="row" alignItems="center" justifyContent="left" spacing={2}>
                <Grid item xs={12} md={6}>
                    <Grid container direction="row" alignItems="center" justifyContent="left" spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                error = {errorUsername}
                                margin="dense"
                                variant="standard"
                                fullWidth
                                type="text"
                                placeholder="Username"
                                label="Username"
                                value={Username}
                                onChange={(e) => { setUsername(e.target.value) }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                error = {errorPassword}
                                margin="dense"
                                fullWidth
                                variant="standard"
                                type="text"
                                placeholder="Password"
                                label="Password"
                                value={Password}
                                onChange={(e) => { setPassword(e.target.value) }}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Box sx={{ alignItems: "center", display: "flex", flexDirection: "row", justifyContent: "flex-start" }}  >
                                <Checkbox
                                    checked={PasswordChangeRequired === "1" ? true : false}
                                    onChange={(e) => { setPasswordChangeRequired(e.target.checked === true ? "1" : "0") }}
                                />
                                <Typography variant='caption'>Require Password Change</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box sx={{ alignItems: "center", display: "flex", flexDirection: "row", justifyContent: "flex-start" }}  >
                                <Checkbox
                                    checked={StatusID === "1" ? true : false}
                                    onChange={(e) => { setStatusID(e.target.checked === true ? "1" : "0") }}
                                />
                                <Typography variant='caption'>Active</Typography>
                            </Box>
                        </Grid>
                        
                    </Grid>
                </Grid>


                <Grid item xs={12} md={6}>
            <Box border={errorGroupGuid ? 1 : 0} sx={{borderColor: "#f44336"}}>

                    <DropdownTreeSelect
                        data={GroupTreeSelect}
                        onChange={onChange}
                        //onAction={onAction} 
                        //onNodeToggle={onNodeToggle}  
                        className="mdl-demo"
                        texts={{ placeholder: "Select Groups" }}
                        keepChildrenOnSearch={true}
                        keepTreeOnSearch={true}
                        showDropdown="always"
                        />
                        </Box>

                </Grid>




                {/* <Grid item xs={12} md={4}>
                    <Box sx={{ alignItems: "center", display: "flex", flexDirection: "row", justifyContent: "flex-start" }}  >
                        <Checkbox
                            checked={LanguageID === "1" ? true : false}
                            onChange={(e) => { setLanguageID(e.target.checked === true ? "1" : "0" ) }}
                        />
                        <Typography variant='caption'>Language</Typography>
                    </Box>
                </Grid> */}


                <Grid item xs={12} md={12}>
                    <Divider />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField
                        margin="dense"
                        fullWidth
                        variant="standard"
                        type="text"
                        placeholder="First Name"
                        label="First Name"
                        value={FirstName}
                        onChange={(e) => { setFirstName(e.target.value) }}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        margin="dense"
                        fullWidth
                        variant="standard"
                        type="text"
                        placeholder="Middle Name"
                        label="Middle Name"
                        value={MiddleName}
                        onChange={(e) => { setMiddleName(e.target.value) }}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        margin="dense"
                        variant="standard"
                        fullWidth
                        type="text"
                        placeholder="Last Name"
                        label="Last Name"
                        value={LastName}
                        onChange={(e) => { setLastName(e.target.value) }}
                    />
                </Grid>



                <Grid item xs={12} md={4}>
                    <TextField sx={{ pr: 4 }}
                        margin="dense"
                        fullWidth
                        error={!validDob}
                        type="date"
                        variant="standard"
                        label="Date of Birth"
                        InputProps={{
                            inputProps: { 
                                max: datToday.toISOString().slice(0, 10)
                                , min: dat120.toISOString().slice(0, 10)
                            }
                        }}
                        InputLabelProps={{ shrink: true }}
                        defaultValue={BioDOB}
                        onChange={(e, nv) => { setBioDOB(e.target.value) }}
                    />
                </Grid>



                <Grid item xs={12} md={4}>
                    <TextField variant="standard" sx={{ width: "100%", overflow: "hidden" }} select size="small"
                        value={BioGender < 0 ? null : BioGender}
                        label="Birth Sex"
                        placeholder="Birth Sex"
                        onChange={(e, nv) => { setBioGender(e.target.value) }}
                    >
                        {birthSexOptions}
                    </TextField>
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField variant="standard" sx={{ width: "100%", overflow: "hidden" }} select size="small"
                        value={BioRace < 0 ? null : BioRace}
                        label="Race"
                        placeholder="Race"
                        onChange={(e, nv) => { setBioRace(e.target.value) }}
                    >
                        {raceOptions}
                    </TextField>
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField variant="standard" sx={{ width: "100%", overflow: "hidden" }} size="small" select
                        value={EducationLevelGuid === "" ? null : EducationLevelGuid}
                        label="Education Level"
                        placeholder="Education Level"
                        onChange={(e, nv) => { setEducationLevelGuid(e.target.value) }}
                    >
                        {eduOptions}
                    </TextField>
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField variant="standard" sx={{ width: "100%", overflow: "hidden" }} select size="small"
                        value={SpokenLanguageID < 0 ? null : SpokenLanguageID}
                        label="Spoken Language"
                        placeholder="Spoken Language"
                        onChange={(e, nv) => { setSpokenLanguageID(e.target.value) }}
                    >
                        {langOptions}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                            <TextField
                                margin="dense"
                                fullWidth
                                variant="standard"
                                type="text"
                                placeholder="Email"
                                label="Email"
                                value={Email}
                                onChange={(e) => { setEmail(e.target.value) }}
                            />
                        </Grid>
                <Grid item xs={12} md={4}>
                    <Box sx={{ alignItems: "center", display: "flex", flexDirection: "row", justifyContent: "flex-start" }}  >
                        <Checkbox
                            checked={Medicaid === "1" ? true : false}
                            onChange={(e) => { setMedicaid(e.target.checked === true ? "1" : "0") }}
                        />
                        <Typography variant='caption'>Medicaid</Typography>
                    </Box>
                </Grid>


                <Grid item xs={12} md={12}>
                    <Box my={2} />
                </Grid>
                {isError === true && (

                    <Grid item xs={12} md={12}>
                        <Typography align="center" color="error" variant="h6">
                            {(ErrorMessage && ErrorMessage.MessageTypeContent) || (createParticipantError && createParticipantError.ErrorMessage) || "ERROR"}
                        </Typography>
                    </Grid>
                )}

                <Grid item xs={12} md={6}>
                    <Box display="flex" justifyContent="end">
                        <Button variant="contained" color="success" onClick={() => { SaveToDatabase() }}
                        disabled={(GroupGuid && StatusID && Username && Password && validDob )? false:true}
                        >Create Participant</Button>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box display="flex" justifyContent="start">
                        <Button variant="contained" color="error" onClick={() => props.onCloseButton()}>Cancel</Button>
                    </Box>

                </Grid>
            </Grid>
        </Box>
    )
}

export default ParticipantCreate